import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    scoreforms: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_SCOREFORM_SELECT_IDS (store, ids) {
      store.scoreforms.selectIds = ids
    },
    REMOVE_SCOREFORM_SELECT_IDS (store, ids) {
      store.scoreforms.selectIds = store.scoreforms.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_SCOREFORM_SELECT_ID (store, id) {
      store.scoreforms.selectId = id
    },
    SET_SCOREFORM_FILTERS (store, filters) {
      store.scoreforms.filters = filters
    },
    SET_SCOREFORM_PAGINATE (store, val) {
      store.scoreforms.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getScoreforms: (store, getters) => {
      return store.scoreforms.selectIds.map((id) => {
        return getters['entities/scoreforms/find'](id)
      })
    },
    getScoreformsFilters: (store, getters) => {
      return store.scoreforms.filters
    },
    getScoreformsPaginate: (store, getters) => {
      return store.scoreforms.paginate
    },
    getScoreform: (store, getters) => {
      return getters['entities/scoreforms/find'](store.scoreforms.selectId) || {}
    }
  },
  actions: {
    /*
    selectScoreforms
    */
    selectScoreforms ({commit, dispatch, getters, state}, filters) {
      return dispatch('getScoreforms', filters)
      .then((response) => {
        commit('SET_SCOREFORM_FILTERS', filters)
        commit('SET_SCOREFORM_PAGINATE', response)
        commit('SET_SCOREFORM_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectScoreforms
    */
    refreshSelectScoreforms ({commit, dispatch, getters, state}) {
      return dispatch('selectScoreforms', getters.getScoreformsFilters)
    },
    /*
    selectScoreform
    */
    selectScoreform ({commit, dispatch, getters, state}, id) {
      return dispatch('getScoreformById', id)
      .then((response) => {
        commit('SET_SCOREFORM_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getScoreforms
    */
    getScoreforms ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/scoreforms`, {params: filters})
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.scoreforms || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getScoreformById
    */
    getScoreformById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/scoreforms/${id}`)
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.scoreforms[0]
      })
    },
    /*
    createScoreform
    */
    createScoreform ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/scoreforms`, data)
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.scoreforms[0]
      })
    },
    /*
    updateScoreform
    */
    updateScoreform ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/scoreforms/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/scoreforms/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.scoreforms[0]
      })
    },
    /*
    deleteScoreform
    */
    deleteScoreform ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/scoreforms/${id}`)
      .then((response) => {
        commit('REMOVE_SCOREFORM_SELECT_IDS', [id])
        dispatch('entities/scoreforms/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Scoreform.js